import { v4 as _uuidv } from "uuid";
const uuidv4 = _uuidv;
export default (class Event {
  constructor(options = {
    start: false,
    end: false,
    duration: false,
    confidence: false,
    rate: 1,
    //TTS speaking rate used when rendering audio description
    speed: 1,
    //Post-render playback speed applied to the rendered audio (preview playbackRate, export atempo)
    pitch: 1,
    //Playback pitch for offline audio description voices
    xPos: "center",
    yPos: "end",
    writingMode: "default",
    // "default" | "horizontal" | "tbrl" (Rosetta r_vertical)
    alignment: "center",
    //left, center, right
    original: "",
    //Original Language for translation
    text: "",
    style: "Pop-On",
    //Pop-On, Paint-On, Roll-Up 2, Roll-Up 3, Roll-Up 4
    tags: [],
    speakers: [],
    recipients: [],
    voice: {
      "provider": "google",
      "name": "en-US-Wavenet-A",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    },
    speakingStyle: "default",
    voiceStability: 50,
    // %
    voiceSimilarity: 50,
    // %
    rendered: true,
    audioRenderHash: "",
    audioFile: "",
    audioFileUuid: false,
    audioFileRemote: "",
    waveformFile: "",
    audioFileDuration: false,
    peaksData: [],
    peaksSampleRate: 0,
    notes: "",
    notesCheck: false,
    reply: "",
    replyCheck: false,
    approved: undefined,
    forced: false,
    track: false,
    //"A" | "B" | "C" | "D" | false (numeric for multiview groups)
    background: "#000000",
    color: "#FFFFFF",
    colors: 0,
    fontSize: false,
    outlineMode: false,
    // "outline" | "drop" | "none" | false (IMSC Rosetta)
    boxing: false,
    // "boxed" | "ghostBoxed" | "stripe" | "ghostStripe" | false
    metadata: []
  }) {
    this.id = uuidv4(), this.start = options.start, this.end = options.end, this.duration = options.duration, this.confidence = options.confidence, this.rate = options.rate || 1, this.speed = options.speed || 1, this.pitch = options.pitch || 1, this.xPos = options.xPos || "center", this.yPos = options.yPos || "end", this.writingMode = options.writingMode || "default", this.alignment = options.alignment || "center", this.original = options.original || "", this.text = options.text || "", this.style = options.style || "Pop-On", this.tags = options.tags || [], this.speakers = options.speakers || [], this.recipients = options.recipients || [], this.voice = options.voice || {
      "provider": "google",
      "name": "en-US-Wavenet-A",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, this.speakingStyle = options.speakingStyle || "default", this.voiceStability = options.voiceStability || 50, this.voiceSimilarity = options.voiceSimilarity || 50, this.rendered = options.rendered ?? true, this.audioRenderHash = options.audioRenderHash || "", this.audioFile = options.audioFile || "", this.audioFileUuid = options.audioFileUuid ?? false, this.audioFileRemote = options.audioFileRemote || "", this.waveformFile = options.waveformFile || "", this.audioFileDuration = options.audioFileDuration, this.peaksData = Array.isArray(options.peaksData) ? options.peaksData : [], this.peaksSampleRate = options.peaksSampleRate || 0, this.notes = options.notes || "", this.reply = options.reply || "", this.notesCheck = options.notesCheck ?? false, this.replyCheck = options.replyCheck ?? false, this.approved = options.approved, this.forced = options.forced, this.track = options.track ?? false, this.background = options.background || "#000000", this.color = options.color || "#ffffff", this.colors = options.colors || 0, this.fontSize = options.fontSize, this.outlineMode = options.outlineMode || false, this.boxing = options.boxing || false, this.metadata = options.metadata || [];
  }
});